// extracted by css-extract-rspack-plugin
export default {"root":"n7fS3","item":"keeVX"};